<template>
    <div id="app">
        <audio style="display: none" ref="audio" controls id="newsAudio">
            <source src="~audios/news.mp3" type="audio/mpeg"/>
        </audio>
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        name: 'app',
        provide(){
            return {
            reload:this.reload
            }
        },
        data(){
            return{
            isRouterAlive:true
            }
        },
        methods: {
            ...mapActions('login', ['getMenus']),
            reload(){
                this.isRouterAlive = false
                this.$nextTick(function(){
                    this.isRouterAlive = true
                })
            }
        },
        created() {
            this.getMenus();
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }
</style>
<style lang="scss">
    @import "assets/style/common";
    @import "assets/style/el-reset";
</style>

